// TODO
import TComment from './index.vue';
import {
  useOptionsVue2,
} from '../core';
import { version } from './package.json';

const install = (Vue, options) => {
  Vue.component(TComment.name, TComment);

  useOptionsVue2(Vue, options);

  if (typeof window !== 'undefined') {
    window.__COMMENT_VERSION__ = version;
  }
};

export default {
  version,
  install,
  TComment,
};
